module.exports = __webpack_public_path__ + "imgs/DCR.c468884ebb68e0c3932ababfeaafa504.png";